






















































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import SerialInfo from "@/store/entities/serialinfo"
import ProductSerial from "@/views/components/view-serials.vue"
import InputSerial from "./input-serial.vue";
import AppConsts from "@/lib/appconst";
import VueLazyload from "vue-lazyload";
import { Circle } from "iview";
import _ from 'lodash';

class PageLocationRequest extends PageRequest {
  keyword: string = "";
}

@Component({
  components: { InputSerial,'view-serials':ProductSerial }
})
export default class Packing extends AbpBase {
  namespace = "packing";
  inputSerialShow: boolean = false;
  viewSerialModelShow: boolean = false;
  itemSerialForView : SerialInfo= new SerialInfo();
  checked: boolean = false;
  isCheckedFastPack: boolean = false;
  storageType: String = "";
  skuCode: String = "";
  model: String = "";
  packageNoPrinted : string = "";
  canShowIterateItem : boolean = true;
  isLoading : boolean = false;
  get store() {
    return this.$store.state.packing;
  }
  //filters
  pagerequest: PageLocationRequest = new PageLocationRequest();

  get loading() {
    return this.store.loading;
  }

  get packingInfo() {
    var re = this.$store.state.packing.item;
    return re;
  }

  get itemSIO() {
    if (this.packingInfo.sioPacking == null) return [];
    var re = this.packingInfo.sioPacking.itemsSioPacking;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = index + 1;
      index++;
    });
    return re;
  }

  get itemMIO() {
    if (this.packingInfo.singleObjectPacking == null || Util.isEmpty(this.packingInfo.singleObjectPacking.objectCode)) return [];
    this.$set(this.packingInfo.singleObjectPacking, 'urlSo', `/#/operations/view/saleorder/${this.packingInfo.singleObjectPacking.objectCode}`);
    var re = this.packingInfo.singleObjectPacking.itemsPacking;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = index + 1;
      index++;
    });
    return re;
  }

  get itemMIO_detail() {
    if (this.packingInfo.singleObjectPacking == null) return [];
    var re = this.packingInfo.singleObjectPacking.objectLines;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = index + 1;
      index++;
    });
    return re;
  }

  get objectsRelated(){
    if(this.packingInfo.singleObjectPacking == null) return[];
    var re = this.packingInfo.singleObjectPacking.ordersRelated;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = index + 1;
      index++;
    });
    return re;
  }

  onReceiptSio(code : string) {
    var url2 = `/#/invoice/${code}/2`;
    window.open(url2, "_blank"); 

    var urlInvTrans = `/#/invoice-transfer/${code}`;
    window.open(urlInvTrans, "_blank"); 
  }

  onShippingLabelSio(soCode : string, packageNo : string) {
    if(packageNo == null || packageNo == ''){
      return;
    }
    
    var url = `/#/shippinglabel/${soCode}/${packageNo}`;
      window.open(url, "_blank");  
  }

  onReceipt(){
    if(this.packingInfo.singleObjectPacking.isCanceled){
      this.showWraningMsg(Util.L("Warning.SoHasBeenCanceled_DoNextStep_EndPacking"));
      return;
    }

    var urlInv2 = `/#/invoice/${this.packingInfo.singleObjectPacking.objectCode}/2`;
    window.open(urlInv2, "_blank"); 

    var urlInvTrans = `/#/invoice-transfer/${this.packingInfo.singleObjectPacking.objectCode}`;
    window.open(urlInvTrans, "_blank"); 
  }

  onShippingLabel() {
    if(this.packingInfo.singleObjectPacking.isCanceled){
      this.showWraningMsg(Util.L("Warning.SoHasBeenCanceled_DoNextStep_EndPacking"));
      return;
    }

    if(this.packageNoPrinted != ""){
      var url = `/#/shippinglabel/${this.packingInfo.singleObjectPacking.objectCode}/${this.packageNoPrinted}`;
      window.open(url, "_blank");  
    } 
  }

  onPrintSoFastPacking(){
    var urlInv2 = `/#/invoice/${this.packingInfo.singleObjectPacking.objectCode}/2`;
    window.open(urlInv2, "_blank"); 
    
    var urlInvTrans = `/#/invoice-transfer/${this.packingInfo.singleObjectPacking.objectCode}`;
    window.open(urlInvTrans, "_blank"); 

    var packageNo = this.packingInfo.singleObjectPacking.deliveryPackages[0].packageNo;
    var urlShippingLabel = `/#/shippinglabel/${this.packingInfo.singleObjectPacking.objectCode}/${packageNo}`;
    window.open(urlShippingLabel, "_blank"); 
  }

  onChangePackagePrinted(event){
    this.packageNoPrinted = event;
  }

  onCalculateShowIterateItem(){
    this.canShowIterateItem = true;
    if(this.packingInfo.singleObjectPacking != null && this.packingInfo.singleObjectPacking.isNoPack){
      this.canShowIterateItem = false;
    }
  }

  columns = [
    {
      title: Util.L("Order"),
      key: "orderNo",
      fixed: 'left',
      width: 70
    },
    {
      title: this.L("SO"),
      width: 150,
      slot: "SOCode",
      align: "center"
    },
    {
      title: Util.L("SKU"),
      width: 200,
      key: "sku"
    },
    {
      title: Util.L("ProductName"),
      width: 250,
      key: "productName"
    },
    {
      title: Util.L("Qty"),
      key: "qty",
      align: "right",
      width:100,
      render: (h: any, params: any) => {
        if(params.row.storageType==="SRL")
          return h("strong", params.row.qty);
        return h("strong", Util.toViewNumberString(params.row.qty));
      }
    },
    {
      title: Util.L("TPL"),
      width: 150,
      key: "tplName"
    },
    {
      title: Util.L("InvoiceNo"),
      width: 200,
      key: "invoiceNo"
    },
    {
      title: Util.L("Groups"),
      width: 150,
      key: "packageNo"
    },
    {
      title: this.L("Action"),
      width: 200,
      slot: "action",
      align: "center"
    }
  ];

  columnsMIO = [
    {
      title: Util.L("Order"),
      key: "orderNo",
      fixed: 'left',
      width: 70
    },
    {
      title: Util.L("SKU"),
      key: "sku",
      width: 200
    },
    {
      title: Util.L("ProductName"),
      key: "productName",
    },
    {
        title:Util.L('Qty'),
        slot: 'qtyPacked',
        align: 'right',
        width: 100,
    },
    {
      title: Util.L("Groups"),
      key: "packageNo",
      fixed:'right',
      width: 150,
      renderHeader: (h: any, params: any) => {
        return h("div", [
          h("span", Util.L("Groups")),
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
                shape: "circle",
                class:"ivu-icon"
              },
              style: {
                marginRight: "5px",
                marginLeft: "5px"
              },
              on: {
                click:()=>{
                                   this.onGroups();
                                }
              }
            },
            Util.L("CreatePackage")
          )
        ]);
      }
    }
  ];

  columnsDetail = [
    {
      title: Util.L("Order"),
      key: "orderNo",
      fixed: 'left',
      width: 70
    },
    {
      title: Util.L("SKU"),
      key: "sku",
      width: 200
    },
    {
      title: Util.L("ProductName"),
      key: "productName",
    },
    {
      title: Util.L("Qty"),
      key: "qty",
      align: "right",
      width:100,
      render: (h: any, params: any) => {
        return h("strong", Util.toViewNumberString(params.row.qty));
      }
    },
    {
      title: Util.L("PickedQty"),
      key: "pickedQty",
      align: "right",
      width:100,
      render: (h: any, params: any) => {
        return h("strong", Util.toViewNumberString(params.row.pickedQty));
      }
    },
    {
      title: Util.L("PackedQty"),
      key: "packedQty",
      align: "right",
      width:100,
      render: (h: any, params: any) => {
        return h("strong", Util.toViewNumberString(params.row.packedQty));
      }
    }
  ];

  onFocusTheFirst(){
    (this.$refs.txtFirstInput as any).focus();
  }

  onFocusInputCode(){
    (this.$refs.txtInputCode as any).focus();
  }

  onBlurInputCode(){
    (this.$refs.txtInputCode as any).blur();
  }

  async created() {
    this.onShowPopupLoading();
    if(this.isLoading)
      return;
    await this.$store.dispatch({
      type: "packing/check"
    }).then(() => {
      this.isLoading = false;
      if(this.packingInfo.workOrderId > 0){
        this.onCalculateShowIterateItem();
        this.onFocusInputCode();
        this.onHidePopupLoading();
        this.setDefaultPackageNo();
      }else{
        this.onFocusTheFirst();
        this.onHidePopupLoading();

        if(this.packingInfo.warningMessage != ''){
          this.showWraningMsg(this.packingInfo.warningMessage);
        }
      }
    })
    .catch(() => {
        this.onRefreshFlagIsLoading();
        this.onHidePopupLoading();
        this.onFocusInputCode();
    });
  }

  setDefaultPackageNo(){
    if(this.packingInfo.singleObjectPacking.deliveryPackages != undefined 
        && this.packingInfo.singleObjectPacking.deliveryPackages.length > 0){
          this.packageNoPrinted = (_.last(this.packingInfo.singleObjectPacking.deliveryPackages)).packageNo;
        }
  }

  async onScan() {
    if (this.packingInfo.workOrderId === 0) {
      if(this.isLoading)
        return;
      this.onShowPopupLoading();
      this.onFreezeFlagIsLoading();
      await this.$store.dispatch({
        type: "packing/init",
        data: { code: this.pagerequest.keyword.trim() }
      })
      .then(() => {
        if(this.packingInfo.warningMessage != ''){
          this.showWraningMsg(this.packingInfo.warningMessage);
        }
        this.onCalculateShowIterateItem();
        this.onFocusInputCode();
        this.onRefreshFlagIsLoading();
        this.onHidePopupLoading();

      })
      .catch(() => {
        this.pagerequest.keyword = "";
        this.onRefreshFlagIsLoading();
        this.onHidePopupLoading();
        this.onFocusInputCode();
      });
    } else {
      await this.$store
        .dispatch({
          type: "packing/checkItem",
          data: { code: this.pagerequest.keyword.trim() }
        })
        .then(result => {
          if (result) {
            const { sku, storageType, isSerial } = result;
            if (
              storageType === "SRL" ||
              (storageType === "N_SRL" && this.checked)
            ) {
              this.skuCode = this.pagerequest.keyword;
              this.storageType = storageType;
              this.onBlurInputCode();
              this.inputSerialShow = true;
            } else {
              this.pushItem({
                previousCode: "",
                qty: 1,
                code: this.pagerequest.keyword.trim()
              });
            }
          }
        })
        .catch(() => {this.onRefreshFlagIsLoading();});
    }
    this.pagerequest.keyword = "";
  }

  async onGroups() {
    await this.$store.dispatch({
      type: "packing/createGroup"
    })
    .then(() => {
      if(this.packingInfo.warningMessage != ''){
        this.showWraningMsg(this.packingInfo.warningMessage);
      }
      this.setDefaultPackageNo();
    });
  }

  async pushItem(data: any) {
    if(this.isLoading)
      return;
    this.onShowPopupLoading();
    this.onFreezeFlagIsLoading();
    await this.$store
      .dispatch({
        type: "packing/pushItem",
        data
      })
      .then(() => {
        this.onFocusInputCode();
        this.onRefreshFlagIsLoading();
        this.onHidePopupLoading();

        if(this.packingInfo.warningMessage != ''){
          this.showWraningMsg(this.packingInfo.warningMessage);
        }

      })
      .catch(() => {
        this.onRefreshFlagIsLoading();
        this.onHidePopupLoading();
      });
  }

  async endTask() {
    this.$Modal.confirm({
      title:this.L('Confirm'),
      content:this.L('YouPrinterAllInoivceAndShippingLabel.YouWantToFinishPackingWorkOrder'),
      okText:this.L('Yes'),
      cancelText:this.L('No'),
      onOk: async()=>{
          if(this.isLoading)
            return;
          this.onShowPopupLoading();
          this.onFreezeFlagIsLoading();
          await this.$store
          .dispatch({
            type: "packing/end"
          })
          .then(() => {
            if(this.packingInfo.warningMessage != ''){
              this.showWraningMsg(this.packingInfo.warningMessage);
            }
            else{
              this.showSuccessMsg("Success.YouFinishedPackingWorkOrder");
            }
            
            this.resetPage();
            this.onRefreshFlagIsLoading();
            this.onHidePopupLoading();
          })
          .catch(() => {
            this.onRefreshFlagIsLoading();
            this.onHidePopupLoading();
          });
      }
    })
  }

  showSuccessMsg(msg: string) {
      Util.showSuccessMsg(this,msg);
  }

  showWraningMsg(msg: string){
    Util.showWarningMsg(this, msg);
  }

  async resetPage(){
    this.packageNoPrinted = "";
    await this.$store.dispatch({
      type: "packing/check"
    }).then(() => {
      this.onFocusTheFirst();
      this.onCalculateShowIterateItem();
      this.isCheckedFastPack = false;
      this.packageNoPrinted = "";
    });
  }

  showSerials (index:number) {
     var rowItem = this.itemMIO[index];
     this.itemSerialForView.sku = rowItem.sku;
     this.itemSerialForView.productName = rowItem.productName;
     this.itemSerialForView.qty = rowItem.qtyPacked;
     this.itemSerialForView.serialNoes = rowItem.serialNoes;
     this.viewSerialModelShow = true;
  }

  getPathThumbnailUrl(name : string){
    return Util.getAppUrlImage(name);
  }

  viewSo(id:string)
  {
      var url = `/#/operations/view/saleorder/${id}`;
      window.open(url, "_blank"); 
  }

  async onMissingItems(){
    this.$Modal.confirm({
      title:this.L('Confirm'),
      content:this.L('DoYouConfirmToMissItems'),
      okText:this.L('Yes'),
      cancelText:this.L('No'),
      onOk: async()=>{
          if(this.isLoading)
            return;
          this.onShowPopupLoading();
          this.onFreezeFlagIsLoading();
          await this.$store
          .dispatch({
            type: "packing/missingItems"
          })
          .then(() => {
            if(this.packingInfo.warningMessage != ''){
              this.showWraningMsg(this.packingInfo.warningMessage);
            }
            else{
              this.showSuccessMsg("Success.YouMissedItemsSuccess");
            }
            
            this.onFocusInputCode();
            this.onRefreshFlagIsLoading();
            this.onHidePopupLoading();
          })
          .catch(() => {
            this.onRefreshFlagIsLoading();
            this.onHidePopupLoading();
          });
      }
    });
  }

  onShowPopupLoading(){
    this.$Message.loading({
      content: this.L("Loading"),
      duration: 0
    });
  }

  onHidePopupLoading(){
    this.$Message.destroy();
  }

  onRefreshFlagIsLoading(){
    this.isLoading = false;
  }

  onFreezeFlagIsLoading(){
    this.isLoading = true;
  }
  async onFastPackItems(){
    this.$Modal.confirm({
      title:this.L('Confirm'),
      content:this.L('DoYouConfirmToFastPackItems'),
      okText:this.L('Yes'),
      cancelText:this.L('No'),
      onOk: async()=>{
          if(this.isLoading)
            return;
          this.onShowPopupLoading();
          this.onFreezeFlagIsLoading();
          await this.$store
          .dispatch({
            type: "packing/fastPackItems"
          })
          .then(() => {
            if(this.packingInfo.warningMessage != ''){
              this.showWraningMsg(this.packingInfo.warningMessage);
            }
            else{
              this.showSuccessMsg("Success.YouFastPackItemsSuccess");
            }
            
            this.setDefaultPackageNo();
            this.onFocusInputCode();
            this.onRefreshFlagIsLoading();
            this.onHidePopupLoading();
          })
          .catch(() => {
            this.onRefreshFlagIsLoading();
            this.onHidePopupLoading();
          });
      }
    });
  }

  columnsOrdersRelated = [
    {
      title: Util.L("Order"),
      key: "orderNo",
      fixed: 'left',
      width: 70
    },
    {
      title: Util.L("TRNSPRT"),
      key: "transportCode",
    },
    {
      title: Util.L("SoCode"),
      key: "soCode",
      align: 'left',
    },
    {
      title: this.L("Action"),
      width: 200,
      slot: "action",
      align: "center"
    }
  ];

  rowDetailClassName(row, index) {
      if (row.qty > row.pickedQty) {
          return 'demo-table-info-row';
      } 

      return '';
  }

  closePopupInputSerialOrQty(){
    this.onFocusInputCode();
  }
}
